import {
  Autocomplete,
  Grid,
  Icon,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import React, { memo, useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import DataTable from "components/Tables/DataTable";
import dataResiduosGenerados from "./dataResiduosGenerados";
import SoftBox from "components/SoftBox";
import { getColor } from "utils/colors";
import SinDatos from "components/Carteles/SinDatos";
import ModalResiduos from "./ModalResiduos";
import { gql, useLazyQuery, useQuery } from "@apollo/client";
import SoftInputNumber from "components/SoftInputNumberUpgrade";
import Separador from "../Separador";
import UNIDADES from "../unidades";

const GET_TRATAMIENTOS = gql`
  query getTratamientos {
    tratamientos {
      id
      item
      descripcion
    }
  }
`;
const GET_EMPRESAS = gql`
  query empresasTransportistas {
    empresasTransportistas {
      id
      razonSocial
    }
  }
`;
const GET_VEHICULOS_EMPRESA = gql`
  query vehiculosEmpresa($idEmpresa: ID!) {
    vehiculosEmpresa(idEmpresa: $idEmpresa) {
      id
      tipo
      marcaModelo
      dominio
    }
  }
`;

const ResiduosGenerados = ({
  listadoResiduosGenerados,
  setListadoResiduosGenerados,
  finalizada,
}) => {
  const [residuo, setResiduo] = useState({});
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedResiduo, setSelectedResiduo] = useState(null);
  const [modalResiduos, setModalResiduos] = useState(false);
  const [empresaElegida, setEmpresaElegida] = useState(null);
  const [vehiculoElegido, setVehiculoElegido] = useState(null); // Agregar este estado
  const [vehiculos, setVehiculos] = useState([]);
  const { data, loading, error } = useQuery(GET_TRATAMIENTOS, {
    fetchPolicy: "no-cache",
  });
  const {
    data: dataEmpresas,
    loading: loadingEmpresa,
    error: errorEmpresa,
  } = useQuery(GET_EMPRESAS, {
    fetchPolicy: "no-cache",
  });
  const { columns, getRows } = dataResiduosGenerados;
  console.log(empresaElegida);
  const [
    getVehiculosEmpresa,
    { data: dataVehiculos, loading: loadingVehiculos, error: errorVehiculos },
  ] = useLazyQuery(GET_VEHICULOS_EMPRESA, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setVehiculos(data.vehiculosEmpresa || []);
    },
  });
  const handleEmpresaChange = (event, newValue) => {
    setEmpresaElegida(newValue);
    setVehiculoElegido(null); // Limpiar el vehículo elegido
    if (newValue?.id) {
      setVehiculos([]);
      getVehiculosEmpresa({ variables: { idEmpresa: newValue.id } });
    } else {
      setVehiculos([]);
    }
  };
  const handleOpenMenu = useCallback((event, item) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    setSelectedResiduo(item);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
    setOpenMenu(false);
    setSelectedResiduo(null);
  }, []);

  const handleChangeResiduo = (e) => {
    const { name, value } = e.target;
    setResiduo((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddResiduo = () => {
    const { idsTratamiento, empresaTransportista, ...newResiduo } = residuo;
    setListadoResiduosGenerados((prev) => [...prev, newResiduo]);
    setResiduo({});
    setEmpresaElegida(null);
    setVehiculos([]);
  };

  const memoizedRows = useMemo(() => {
    if (listadoResiduosGenerados) {
      const listadoSinBorrar = listadoResiduosGenerados.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar, handleOpenMenu, finalizada);
    }
    return [];
  }, [listadoResiduosGenerados, handleOpenMenu, finalizada]);

  // Render del menú contextual
  const renderMenu = !finalizada && (
    <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(openMenu)} onClose={handleCloseMenu}>
      <MenuItem
        onClick={() => {
          handleCloseMenu();
          setListadoResiduosGenerados((prev) => {
            if (selectedResiduo.id) {
              return prev.map((item) => {
                if (item.id === selectedResiduo.id) {
                  return { ...item, aBorrar: true };
                }
                return item;
              });
            } else {
              return prev.filter((item) => item !== selectedResiduo);
            }
          });
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <SoftTypography variant="p">Quitar</SoftTypography>
          <Icon fontSize="small" sx={{ verticalAlign: "middle", color: getColor("gobSecondary") }}>
            delete
          </Icon>
        </SoftBox>
      </MenuItem>
    </Menu>
  );
  return (
    <Grid container p={2}>
      <Grid item xs={12}>
        <SoftTypography variant="h4" fontWeight="bold">
          Residuos Generados
        </SoftTypography>
      </Grid>
      {!finalizada && (
        <Grid item xs={12}>
          <Grid container p={2} spacing={1}>
            <Grid item xs={2} md={2}>
              <InputLabel htmlFor="tipoResiduo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Elegir tipo de residuo
                </SoftTypography>
              </InputLabel>
              <SoftButton
                variant="gradient"
                color="primary"
                fullWidth
                onClick={() => {
                  setModalResiduos(true);
                }}
              >
                Elegir <Icon>open_in_new</Icon>
              </SoftButton>
            </Grid>
            <Grid item xs={4} md={4}>
              <InputLabel htmlFor="tipoResiduo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Tipo de Residuo elegido
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="tipoResiduo"
                placeholder="Sin elegir"
                value={residuo.tipoResiduo || ""}
                fullWidth
                name="tipoResiduo"
                onChange={handleChangeResiduo}
                disabled
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <InputLabel htmlFor="descripcionResiduo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Descripción del Residuo elegido
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="descripcionResiduo"
                placeholder="Sin elegir"
                value={residuo.descripcionResiduo || ""}
                fullWidth
                name="descripcionResiduo"
                onChange={handleChangeResiduo}
                disabled
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="cantidadResiduo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidadResiduo"
                placeholder="Cantidad"
                value={residuo.cantidadResiduo || ""}
                fullWidth
                name="cantidadResiduo"
                onChange={handleChangeResiduo}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <InputLabel htmlFor="unidadResiduo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Unidad
                </SoftTypography>
              </InputLabel>
              <Select
                id="unidadResiduo"
                placeholder="Unidad"
                value={residuo.unidadResiduo || ""}
                name="unidadResiduo"
                fullWidth
                onChange={handleChangeResiduo}
              >
                {UNIDADES.map((unidad) => (
                  <MenuItem key={unidad} value={unidad}>
                    {unidad}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={6} md={6}>
              <InputLabel htmlFor="observacion">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Observación
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="observacion"
                placeholder="Observación"
                value={residuo.observacion || ""}
                fullWidth
                name="observacion"
                onChange={handleChangeResiduo}
              />
            </Grid>
            <Grid item xs={residuo.idTratamiento == 12 ? 4 : 12}>
              <InputLabel htmlFor="tipoResiduo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Elegir tipo de tratamiento
                </SoftTypography>
              </InputLabel>
              <Select
                disabled={!residuo.idsTratamiento}
                placeholder={!residuo.idsTratamiento ? "Elija tipo de residuo" : ""}
                id="tipoTratamiento"
                onChange={(e) => {
                  const value = e.target.value;
                  setResiduo((prev) => ({
                    ...prev,
                    idTratamiento: value.id,
                    tipoTratamiento: value.item,
                    descripcionTratamiento: value.descripcion,
                  }));
                }}
              >
                {data?.tratamientos
                  ?.filter((item) => residuo.idsTratamiento?.includes(item.id))
                  .map((item) => (
                    <MenuItem key={item.id} value={item}>
                      {`${item.item}${item.descripcion ? ` - ${item.descripcion}` : ""}`}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            {residuo.idTratamiento == 12 && (
              <Grid item xs={8} md={8}>
                <InputLabel htmlFor="tipoResiduo">
                  <SoftTypography component="label" variant="caption" fontWeight="bold">
                    Descripción del tratamiento
                  </SoftTypography>
                </InputLabel>
                <SoftInput
                  id="descripcionTratamiento"
                  placeholder="Descripción del tratamiento"
                  value={residuo.descripcionTratamiento || ""}
                  fullWidth
                  name="descripcionTratamiento"
                  onChange={handleChangeResiduo}
                />
              </Grid>
            )}
            <Grid item xs={6}>
              <InputLabel htmlFor="cantidadTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Cantidad
                </SoftTypography>
              </InputLabel>
              <SoftInputNumber
                id="cantidadTratamiento"
                placeholder="Cantidad"
                value={residuo.cantidadTratamiento || ""}
                fullWidth
                name="cantidadTratamiento"
                onChange={handleChangeResiduo}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel htmlFor="unidadTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Unidad
                </SoftTypography>
              </InputLabel>
              <Select
                id="unidadTratamiento"
                placeholder="Unidad"
                value={residuo.unidadTratamiento || ""}
                fullWidth
                name="unidadTratamiento"
                onChange={handleChangeResiduo}
              >
                {UNIDADES.map((unidad) => (
                  <MenuItem key={unidad} value={unidad}>
                    {unidad}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={4}>
              <InputLabel htmlFor="unidadTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Empresa Transportista
                </SoftTypography>
              </InputLabel>
              <Autocomplete
                id="actividad"
                size="small"
                noOptionsText="No hay resultados"
                options={dataEmpresas?.empresasTransportistas || []}
                getOptionLabel={(option) => `${option.razonSocial} `}
                value={empresaElegida} // Agregar esta línea
                onChange={(event, newValue) => {
                  if (!newValue) {
                    setEmpresaElegida(null);
                    setVehiculoElegido(null); // Limpiar vehículo elegido
                    setResiduo((prev) => ({
                      ...prev,
                      vehiculo: "",
                      idVehiculo: null,
                      empresaTransportista: "",
                      idEmpresaVehiculo: null,
                    }));
                    setVehiculos([]);
                    return;
                  }
                  handleEmpresaChange(event, newValue);
                  setResiduo((prev) => ({
                    ...prev,
                    vehiculo: "",
                    idVehiculo: null,
                    empresaTransportista: newValue ? newValue.razonSocial : "",
                    idEmpresaVehiculo: newValue ? newValue.id : null,
                  }));
                }}
                renderInput={(params) => <TextField {...params} />}
              />
            </Grid>
            <Grid item xs={4}>
              <InputLabel htmlFor="unidadTratamiento">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Vehículo Transportista
                </SoftTypography>
              </InputLabel>
              <Autocomplete
                id="vehiculoTransportista"
                size="small"
                noOptionsText="No hay vehículos disponibles"
                options={vehiculos}
                value={vehiculoElegido} // Agregar esta línea
                getOptionLabel={(option) =>
                  `${option.tipo} - ${option.marcaModelo} (${option.dominio})`
                }
                onChange={(event, newValue) => {
                  setVehiculoElegido(newValue); // Actualizar el estado del vehículo elegido
                  if (!newValue) {
                    setResiduo((prev) => ({
                      ...prev,
                      vehiculo: "",
                      idVehiculo: null,
                      idEmpresaVehiculo: empresaElegida?.id || null,
                    }));
                    return;
                  }
                  setResiduo((prev) => ({
                    ...prev,
                    vehiculo: `${empresaElegida?.razonSocial} / ${newValue.tipo} - ${newValue.marcaModelo} (${newValue.dominio})`,
                    idVehiculo: newValue.id,
                    idEmpresaVehiculo: empresaElegida?.id || null,
                  }));
                }}
                renderInput={(params) => <TextField {...params} />}
                disabled={loadingVehiculos || !empresaElegida}
              />
            </Grid>
            <Grid item xs={4} display={"flex"} alignItems="flex-end">
              <SoftButton
                variant="gradient"
                color="primary"
                fullWidth
                onClick={handleAddResiduo}
                disabled={
                  !residuo.tipoResiduo ||
                  !residuo.descripcionResiduo ||
                  !residuo.cantidadResiduo ||
                  !residuo.unidadResiduo ||
                  !residuo.idTratamiento ||
                  !residuo.tipoTratamiento ||
                  !residuo.descripcionTratamiento ||
                  !residuo.cantidadTratamiento ||
                  !residuo.unidadTratamiento
                }
              >
                Agregar +
              </SoftButton>
            </Grid>
          </Grid>
        </Grid>
      )}
      {!finalizada && <Separador />}
      <Grid item xs={12} py={1}>
        {listadoResiduosGenerados?.filter((item) => !item.aBorrar).length > 0 ? (
          <DataTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay residuos generados cargados" />
        )}
        {renderMenu}
      </Grid>
      <ModalResiduos
        open={modalResiduos}
        handleClose={() => setModalResiduos(false)}
        setResiduo={setResiduo}
        residuo={residuo}
      />
    </Grid>
  );
};

export default memo(ResiduosGenerados);

ResiduosGenerados.propTypes = {
  idDeclaracion: PropTypes.string.isRequired,
  listadoResiduosGenerados: PropTypes.array.isRequired,
  setListadoResiduosGenerados: PropTypes.func.isRequired,
  finalizada: PropTypes.bool,
};
